import React from "react";

/**
 * Cyber-owl logo — dark rounded tile, glowing cyan owl silhouette,
 * animated eyes (blink + look around).
 */
export default function OwlLogo({ size = 42 }) {
  const s = size;
  const r = s * 0.28;
  return (
    <div
      style={{
        width: s, height: s, borderRadius: r,
        border: "2px solid #0F1120",
        boxShadow: "3px 3px 0 0 #0F1120",
        background: "linear-gradient(135deg,#1A0F46 0%,#2C166C 40%,#5B21AC 70%,#075985 100%)",
        position: "relative", overflow: "hidden",
      }}
    >
      {/* subtle glow */}
      <div style={{
        position: "absolute", inset: "8%",
        background: "radial-gradient(circle at 50% 55%, rgba(100,220,255,0.35), transparent 65%)",
      }}/>
      <svg
        width={s} height={s} viewBox="0 0 100 100"
        style={{ position: "absolute", inset: 0 }}
        aria-hidden="true"
      >
        {/* Ear tufts */}
        <polygon points="30,26 36,10 44,28"
          fill="#8CDCFF" stroke="#0F1120" strokeWidth="2" strokeLinejoin="round"/>
        <polygon points="56,28 64,10 70,26"
          fill="#8CDCFF" stroke="#0F1120" strokeWidth="2" strokeLinejoin="round"/>

        {/* Body */}
        <ellipse cx="50" cy="60" rx="28" ry="30"
          fill="#1E2952" stroke="#8CDCFF" strokeWidth="2.5" className="owl-glow"/>

        {/* Head (rounded top of body) */}
        <ellipse cx="50" cy="42" rx="24" ry="22"
          fill="#324182" stroke="#8CDCFF" strokeWidth="2.5" className="owl-glow"/>

        {/* Wings */}
        <path d="M 24 55 Q 22 74 30 78 L 34 60 Z" fill="#4C5FA8" stroke="#0F1120" strokeWidth="1.6"/>
        <path d="M 76 55 Q 78 74 70 78 L 66 60 Z" fill="#4C5FA8" stroke="#0F1120" strokeWidth="1.6"/>

        {/* Left eye */}
        <g className="owl-eye" style={{ animationDelay: "0s" }}>
          <circle cx="40" cy="43" r="9" fill="#F0FAFF" stroke="#0F1120" strokeWidth="2"/>
          <circle cx="40" cy="43" r="6.5" fill="#64DCFF"/>
          <circle className="owl-pupil" cx="40" cy="43" r="3.5" fill="#0F1120"/>
          <circle cx="38.4" cy="41.4" r="1.4" fill="#FFFFFF"/>
        </g>

        {/* Right eye */}
        <g className="owl-eye" style={{ animationDelay: "0.15s" }}>
          <circle cx="60" cy="43" r="9" fill="#F0FAFF" stroke="#0F1120" strokeWidth="2"/>
          <circle cx="60" cy="43" r="6.5" fill="#64DCFF"/>
          <circle className="owl-pupil" cx="60" cy="43" r="3.5" fill="#0F1120"/>
          <circle cx="58.4" cy="41.4" r="1.4" fill="#FFFFFF"/>
        </g>

        {/* Beak */}
        <polygon points="50,55 46,62 54,62"
          fill="#FFD93D" stroke="#0F1120" strokeWidth="1.4" strokeLinejoin="round"/>

        {/* Feet */}
        <path d="M 42 88 L 39 92 M 42 88 L 45 92
                 M 58 88 L 55 92 M 58 88 L 61 92"
          stroke="#FFD93D" strokeWidth="2.2" strokeLinecap="round" fill="none"/>
      </svg>
    </div>
  );
}
